module.exports = __webpack_public_path__ + "00abbbf568573cba25e359ffe09633a8.png";